import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './NavUserActions.css';

export default class NavUserActions extends Component {

    render(props) {
        return (
            <div>
                {
                    this.props.isAuthenticated && (
                        <div className="nav-useractions" >
                            <span className="nav-useractions-text">Customer Portal</span> <span> | {this.props.auth.user.userName} |</span> <Link to={'/'}><span className="nav-useractions-text" onClick={() => { this.props.signOut(); }}> Log Off</span></Link>
                        </div>
                    )
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Nav/NavUserActions.js